export default __webpack_public_path__ + "static/mergevideos-d12f00af108b82ea7e88cfefa8d209bf.png";